/**
 * APEX v8.2.4 — useHashRouter
 * Fix : lecture synchrone du hash au premier render,
 * les pages légales s'affichent avant même que l'auth charge.
 */

import { useState, useEffect, useCallback } from 'react';

function getRoute() {
  if (typeof window === 'undefined') return '/';
  const hash = window.location.hash;
  if (!hash || hash === '#' || hash === '#/') return '/';
  const path = hash.replace(/^#/, '').split('?')[0];
  return path || '/';
}

export function useHashRouter() {
  const [route, setRoute] = useState(() => getRoute());

  useEffect(() => {
    const onHashChange = () => setRoute(getRoute());
    window.addEventListener('hashchange', onHashChange);
    setRoute(getRoute()); // relire après mount
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const navigate = useCallback((path) => {
    window.location.hash = path;
  }, []);

  return { route, navigate };
}
